module.exports = __webpack_public_path__ + "img/Picture5.da6eb818.jpg";